import type {RtcLogger} from '@phonehq/rtc-core';
import logger from '../../../services/logger';

const SENSITIVE_KEY = /token|jwt|secret|password|passphrase|sdp|candidate|authorization|cookie|^key$|keys$|material|ciphertext/i;
const JWT_PATTERN = /eyJ[\w-]+\.[\w-]+\.[\w-]*/g;
const BEARER_PATTERN = /bearer\s+[\w.~+/=-]+/gi;
const SDP_PATTERN = /(^|\r?\n)(v=0|a=candidate|a=fingerprint|a=ice-pwd|a=ice-ufrag|m=(audio|video|application))/;
const MAX_STRING_LENGTH = 300;

const scrubString = (value: string): string => {
    if (SDP_PATTERN.test(value)) {
        return '[redacted]';
    }
    const scrubbed = value.replace(JWT_PATTERN, '[redacted]').replace(BEARER_PATTERN, '[redacted]');
    return scrubbed.length > MAX_STRING_LENGTH ? `${scrubbed.slice(0, MAX_STRING_LENGTH)}…` : scrubbed;
};

export const redactRtcContext = (context: Record<string, unknown> | undefined): Record<string, string | number | boolean | null> => {
    const result: Record<string, string | number | boolean | null> = {};
    if (!context) {
        return result;
    }
    for (const [key, value] of Object.entries(context)) {
        if (SENSITIVE_KEY.test(key)) {
            continue;
        }
        if (typeof value === 'string') {
            result[key] = scrubString(value);
        } else if (typeof value === 'number' || typeof value === 'boolean' || value === null) {
            result[key] = value;
        }
    }
    return result;
};

export const groupCallRtcLogger: RtcLogger = {
    debug: (message, context) => logger.debug(message, {source: 'group_call', event: 'rtc_core', rtcEvent: message, ...redactRtcContext(context)}),
    info: (message, context) => logger.info(message, {source: 'group_call', event: 'rtc_core', rtcEvent: message, ...redactRtcContext(context)}),
    warn: (message, context) => logger.warn(message, {source: 'group_call', event: 'rtc_core', rtcEvent: message, ...redactRtcContext(context)}),
    error: (message, context) => logger.error(message, {source: 'group_call', event: 'rtc_core', rtcEvent: message, ...redactRtcContext(context)}),
};
